@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

.container {
  width: 100%;
  padding: 45px 0 25px;
}

.row {
  display: flex;
  flex-flow: row wrap;
  max-width: 1500px;
}

.section {
  max-width: 360px;
  min-width: 225px;
  margin: 0 30px 30px 0;
  display: flex;
  flex-direction: row;
}

.left-side {
  width: 60px;
  margin-right: 10px;

  > svg {
    height: 40px;
    width: 40px;
    margin-left: 10px;
    margin-top: 10px;
    fill: @settings-page--popular--icon-color;
  }
}

.fa-icon {
  fill: @white;
  > path {
    fill: @white;
  }
}

.subsection {
  display: flex;
  flex-direction: column;
  margin-top: 15px;

  button {
    margin-bottom: 3px;
    display: inherit;
    font-size: 16px;
  }

  .disabled-text {
    color: @settings-page--popular--disabled--text-color;
    margin-bottom: 5px;
  }
}

.shipping-supplies-card {
  max-width: 1170px;
  border-radius: 8px;
  border: 1px solid var(--grey-300);
  padding: @space-24;
  background-color: var(--grey-200);
  justify-content: flex-start;
}

.shipping-supplies {
  max-width: 562px;
  height: 100%;
  width: 100%;
}

.shipping-supllies-title {
  width: 100%;
  align-content: flex-start;
}

.shipping-supplies-icon {
  height: 32px;
  padding-right: @space-16;
}

.shipping-supplies-link-icon {
  width: 13px;
  margin-left: @space-8;
}

.shipping-supplies-content {
  padding-left: 55px;
  max-width: 652px;
}

.add-ons-header-row {
  align-items: center;
  gap: @space-8;
}
